"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECOND_STAGE_WIDTH = exports.FIRST_STAGE_WIDTH_MOBILE = exports.FIRST_STAGE_WIDTH = exports.BASE_STAGE_COLOR = void 0;
var BASE_STAGE_COLOR = {
  r: 241,
  g: 247,
  b: 210
};
exports.BASE_STAGE_COLOR = BASE_STAGE_COLOR;
var FIRST_STAGE_WIDTH_MOBILE = 126;
exports.FIRST_STAGE_WIDTH_MOBILE = FIRST_STAGE_WIDTH_MOBILE;
var FIRST_STAGE_WIDTH = 178;
exports.FIRST_STAGE_WIDTH = FIRST_STAGE_WIDTH;
var SECOND_STAGE_WIDTH = 72;
exports.SECOND_STAGE_WIDTH = SECOND_STAGE_WIDTH;